import React, { memo } from "react";
import { SidebarPanel } from "../sidebar-panel";
import { Slider } from "../../slider";
import { usePhotoFilters } from "../../../hooks/use-photo-filters";
import { useLabels } from "../../../hooks/useLabels";
import { labels } from "./labels";

export const SidebarFilterEffectsPanel = memo(() => {
	const { brightness, contrast, saturation, canApplyPhotoFilters } = usePhotoFilters();

	const [[filtersTitle, brightnessTitle, contrastTitle, saturationTitle], isLoadingLabels] =
		useLabels([labels.filters, labels.brightness, labels.contrast, labels.saturation]);

	if (isLoadingLabels) {
		return null;
	}

	return (
		<SidebarPanel.Root>
			<SidebarPanel.Content scrollable fade>
				<SidebarPanel.Title>{filtersTitle}</SidebarPanel.Title>
				<SidebarPanel.SubTitle>{brightnessTitle}</SidebarPanel.SubTitle>
				<Slider
					value={brightness.currentUISliderValue}
					min={-100}
					max={100}
					onChange={brightness.onChange}
					disabled={!canApplyPhotoFilters}
					snapToZeroValue={5}
				/>
				<SidebarPanel.SubTitle>{saturationTitle}</SidebarPanel.SubTitle>
				<Slider
					value={saturation.currentUISliderValue}
					min={-100}
					max={100}
					onChange={saturation.onChange}
					disabled={!canApplyPhotoFilters}
					snapToZeroValue={5}
				/>
				<SidebarPanel.SubTitle>{contrastTitle}</SidebarPanel.SubTitle>
				<Slider
					value={contrast.currentUISliderValue}
					min={-100}
					max={100}
					onChange={contrast.onChange}
					disabled={!canApplyPhotoFilters}
					snapToZeroValue={5}
				/>
			</SidebarPanel.Content>
		</SidebarPanel.Root>
	);
});
SidebarFilterEffectsPanel.displayName = "SidebarFilterEffectsPanel";
